<template>
    <div class="memberwork-card left-align" v-html="cardHtml" :style="{transform: transformStyle, left: leftStyle}">

    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, computed} from 'vue'
    import myUtil from "@/util/util";
    import {getWhatsAppIcon} from "@/util/svgIconCode";

    const { proxy } = getCurrentInstance();

    const props = defineProps(['htmlText', 'webmem', 'scaleWidth', 'leftDistance'])
    const emits = defineEmits(["scalePercent"])

    const cardHtml = computed(() => {
        if (null == props.htmlText){
            return ""
        }else{
            let imgFileName = ""
            let fileName = ""
            let html = props.htmlText

            if (myUtil.isNotEmpty(html)){
                const dom = document.createElement("div");

                dom.innerHTML = html

                const list = dom.getElementsByClassName("fa-whatsapp")

                for (let i=0; i<list.length; i++){
                    const item = list[i]
                    const setting = {}

                    if (myUtil.isNotEmpty(item.style.color)){
                        setting.color = myUtil.rgbToHexColor(item.style.color)
                    }

                    item.innerHTML = getWhatsAppIcon(setting)
                }

                html = dom.innerHTML
                dom.remove()

            }

            if (props.webmem == -1){
                fileName = "auth-1.png"
            }else if (null == props.webmem){
                return html
            }else{
                fileName = "auth-0.png"
            }

            imgFileName = `/static/images/${fileName}`

            const authImgDom = `<div style="position: absolute; top: -40px; right: -3px; opacity: 0.4; z-index: 500;"><img src="${imgFileName}" style="width: 80px; height: 80px;"></div>`

            html = authImgDom + html

            html = html.replaceAll(`src="`, `src="${proxy.$ShopopeeUrl}/`)

            return html
        }
    })

    const transformStyle = computed(() =>{
        if(null == props.scaleWidth){
            emits("scalePercent", 1)
            return `scale(1)`
        }else{
            emits("scalePercent", props.scaleWidth / 425)
            return `scale(${props.scaleWidth / 425})`
        }
    })

    const leftStyle = computed(() =>{
        if(null == props.leftDistance){
            return ``
        }else{
            return `${props.leftDistance}px`
        }
    })

    // onMounted(() => {
    //
    // })

</script>

<style scoped>

</style>

<style>
    .left-align {
        text-align: left;
    }

    .memberwork-card {
        height: 275px;
        width: 425px;
        position: relative;
        border: 0 solid;
        box-shadow:5px 5px 10px #aaaaaa;
        background-color: #FFFFFF;
        margin:0 auto;
        border-radius: 10px;
        user-select: none;

        transform-origin: 0 0;
    }

    .memberwork-card .bgImgItem img{
        border-radius: 10px;
    }

    .memberwork-card .bgSeItem img{
        border-radius: 10px;
    }

    .memberwork-card a {
        color: unset;
        text-decoration: none;
        transition: 0.5s all ease;
    }

    .memberwork-card a:hover {
        text-decoration: none;
        color: #e83f33
    }

    .memberwork-card a:focus {
        outline: 0;
        text-decoration: none;
        color: #666
    }

    .workcard-phone-hide{
        display: none;
    }

    .memberwork-card .person-card-tag~.memberwork-item .workposition,
    .memberwork-card .person-card-tag~.memberwork-item .logoFile,
    .memberwork-card .person-card-tag~.memberwork-item .workcompany,
    .memberwork-card .person-card-tag~.memberwork-item .workcompany2,
    .memberwork-card .person-card-tag~.memberwork-item .companytelphone,
    .memberwork-card .person-card-tag~.memberwork-item .companyemail,
    .memberwork-card .person-card-tag~.memberwork-item .companyaddress,
    .memberwork-card .person-card-tag~.memberwork-item .companyaddress2,
    .memberwork-card .person-card-tag~.memberwork-item .companytelphone,
    .memberwork-card .person-card-tag~.memberwork-item .companytelphone2,
    .memberwork-card .person-card-tag~.memberwork-item .companyfax,
    .memberwork-card .person-card-tag~.memberwork-item .companyinfo,
    .memberwork-card .person-card-tag~.memberwork-item .companyTelWhatsApp{
        display: none !important;;
    }

    .memberwork-card .memberwork-item {
        line-height: 1;
    }

</style>